import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';


//Componentes Atentus
//import ActiveObjectives from './components/ActiveObjectives';
//import InactiveObjectives from './components/InactiveObjectives';
import SummaryObjectives from '../Dashboard/components/SummaryObjectives'
//import SummaryObjectives from './components/SummaryObjectives';


// Component styles
const styles = theme => ({
    root: {
        padding: theme.spacing(3),
        backgroundColor: '#525252',
        height: '100%',
    },
    item: {
        height: '100%'
    }
});

class ObjectiveService extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            objectivesList: {}
        } 
    }
    myCallback = (dataFromChild) => {

        this.setState({
            objectivesList: dataFromChild
        })


    }

    render() {
        const { classes } = this.props;
        const { objectivesList } = this.state
        return (
            <DashboardLayout title="" callbackFromParent={this.myCallback} isFirstTime={true}>
                <div className={classes.root}>
                    <Grid
                        container
                        spacing={10}
                    >
                        {/* OBJETIVOS ACTICOS */}
                        {/*<Grid
                            item
                            sm={3}
                            xl={6}
                            xs={12}
                        >
                            <ActiveObjectives />
                        </Grid>
                        <Grid
                            item
                            sm={3}
                            xl={6}
                            xs={12}
                        >
                            <InactiveObjectives />
                        </Grid>*/}

                        <Grid
                            item
                            sm={12}
                            xl={12}
                            xs={12}
                        >
                            <SummaryObjectives params={objectivesList} />
                        </Grid>
                    </Grid>
                </div>
            </DashboardLayout>
        );
    }
}

ObjectiveService.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ObjectiveService);
